export default __webpack_public_path__ + "static/tech-sheet-mobile-3c7bda1c93e09eff92e8bf72fb9c7010.png";